import EINO from "../../assets/EINO.png";
import DarulMasajid from "../../assets/darul_masajid.png";
import MyNextFilms from "../../assets/mynextfilm.png";
import Pathshala from "../../assets/Pathshala.png";
import Summachar from "../../assets/summachar.png";

export const PortfolioData = [
    {
        "image": EINO,
        "title": "EINO",
        "link": "https://app.eino.world/",
        "worked between": "01/08/22 - current"
    },
    {
        "image": DarulMasajid,
        "title": "Darul Masajid",
        "link": "https://play.google.com/store/apps/details?id=com.incupad.prod.masjid&hl=en_US",
        "worked between": "07/04/22 - 20/07/22"
    },
    {
        "image": MyNextFilms,
        "title": "MyNextFilms",
        "link": "https://mynextfilm.com/viewerlounge",
        "worked between": "01/03/22 - 01/04/22"
    },
    {
        "image": Summachar,
        "title": "Summachar",
        "link": "https://www.summachar.in/",
        "worked between": "01/08/21 - 26/01/2022"
    },
    {
        "image": Pathshala,
        "title": "Pathshala by Summachar",
        "link": "https://play.google.com/store/apps/details?id=in.summachar.pathshala&hl=en_IN&gl=US",
        "worked between": "01/08/21 - 26/01/2022"
    },
]